import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // Used when no locale matches
  defaultLocale: "en",

  // Default locale (en) has no prefix, other locales have prefix
  localePrefix: "always",

  locales: ["en", "fr"],

  pathnames: {
    "/apps": {
      en: "/apps",
      fr: "/apps",
    },
    "/apps/[slug]": {
      en: "/apps/[slug]",
      fr: "/apps/[slug]",
    },
    "/tools": {
      en: "/tools",
      fr: "/outils",
    },
    "/tools/[slug]": {
      en: "/tools/[slug]",
      fr: "/outils/[slug]",
    },
    "/tutorials": {
      en: "/tutorials",
      fr: "/tutoriels",
    },
    "/tutorials/[slug]": {
      en: "/tutorials/[slug]",
      fr: "/tutoriels/[slug]",
    },
  },
});

// Shared locale type derived from routing configuration
export type Locale = (typeof routing.locales)[number];

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
// eslint-disable-next-line @typescript-eslint/naming-convention
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);
